import { render, staticRenderFns } from "./QuickAlerts.vue?vue&type=template&id=38d4d0c2&"
import script from "./QuickAlerts.vue?vue&type=script&lang=js&"
export * from "./QuickAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports